<div *ngIf="sessionData" class="ViewMessage container">
  <div class="meeting-controls">
    <app-button
      [Click]="back.bind(this)"
      [color]="'white'"
      [text]="'Back'"></app-button>
    <app-button
      [Click]="restore.bind(this)"
      [color]="'orange'"
      [text]="'Restore'"></app-button>
  </div>
  <h4>Meeting details</h4>
  <div class="details">
    <ul>
      <li>Name: {{ meetingData.contact_name }}</li>
      <li>Company: {{ meetingData.contact_company }}</li>
      <li>Primary email: {{ meetingData.contact_email }}</li>
      <li>Primary phone number: {{ meetingData.contact_phone }}</li>
      <li>
        Meeting date:
        {{
          meetingData.meeting_date
            | timezone: 'MM/dd/YYYY hh:mm a' : sessionData.time_zone
        }}
      </li>
      <li>Current reply action: {{ meetingData.replay_action }}</li>
      <li>Next email date: {{ meetingData.next_email }}</li>
      <li>Notes: {{ meetingData.meeting_notes }}</li>
    </ul>
  </div>

  <h4 class="underlined">Asociated products</h4>

  <div class="products-list">
    <section
      *ngIf="
        meetingData && meetingData.products && meetingData.products.length > 0
      ">
      <header>
        <div class="col">Product name</div>
        <div class="col">Description</div>
        <div class="col">Estimated value</div>
        <div class="col">Estimated closing date</div>
        <div class="col">Current Status</div>
        <div class="col">Pipeline</div>
        <div class="col">Status Date</div>
        <div class="col">Actual value</div>
        <div class="col">Renewal date</div>
      </header>
      <div *ngFor="let product of meetingData.products" class="rowz">
        <div class="col">{{ product.name }}</div>
        <div class="col">{{ product.description }}</div>
        <div class="col">{{ product.est_value }}</div>
        <div class="col">
          {{
            product.est_close_date
              | timezone: 'MM/dd/YYYY hh:mm a' : sessionData.time_zone
          }}
        </div>
        <div class="col">{{ product.current_status }}</div>
        <div class="col">{{ product.pipeline }}</div>
        <div class="col">
          {{
            product.status_date
              | timezone: 'MM/dd/YYYY hh:mm a' : sessionData.time_zone
          }}
        </div>
        <div class="col">{{ product.actual_value }}</div>
        <div class="col">
          {{
            product.renewal_date
              | timezone: 'MM/dd/YYYY hh:mm a' : sessionData.time_zone
          }}
        </div>
      </div>
    </section>
  </div>

  <div class="flex-row d-flex response-button-holder">
    <div class="flex-grow-1">
      <div
        *ngIf="getMessageCampaing()"
        class="ViewMessage-campaingd-flex-flex-column">
        <p><b>Campaing: </b>{{ getMessageCampaing() }}</p>
      </div>
    </div>

    <div class="holder">
      <app-button-select
        *ngIf="responseButtonSelect && responseButtonSelect.buttonProperties"
        [buttonProperties]="responseButtonSelect.buttonProperties"
        [items]="responseButtonSelect.items"></app-button-select>
    </div>
  </div>
  <div class="ViewMessage-nav d-flex flex-row view-msg-campaign">
    <div *ngIf="preMessageId" class="ViewMessage-nav-button flex-grow-1">
      <app-button
        [Click]="onNavigationButtonClick.bind(this, 'prev')"
        [color]="'green'"
        [text]="'Previous'"></app-button>
    </div>
    <div *ngIf="nextMessageId" class="ViewMessage-nav-button flex-grow-1">
      <app-button
        [Click]="onNavigationButtonClick.bind(this, 'next')"
        [color]="'green'"
        [text]="'Next'"></app-button>
    </div>
    <div class="ViewMessage-nav-plain flex-grow-1 d-flex align-items-center">
      <mat-checkbox
        (change)="viewAsPlain = $event.checked"
        [value]="viewAsPlain"
        >View as plain</mat-checkbox
      >
    </div>
    <div *ngIf="hasResponseStatus()" class="ViewMessage-nav-plain flex-grow-1">
      <p class="text-left text-capitalize mb-0">
        <b>Current Status: </b>{{ getResponseStatus() }}
      </p>
      <p class="text-left mb-0">
        <b>Next Email Date: </b>{{ getNextEmailDate() }}
      </p>
    </div>
  </div>
  <ng-container *ngIf="messages && messages.length > 0">
    <div class="view-msg-campaign">
      <app-message-viewer
        *ngFor="let message of messages"
        [asPlainText]="viewAsPlain"
        [message]="message"
        [sessionData]="sessionData"></app-message-viewer>
    </div>
  </ng-container>
</div>
